require('./complement-adresse.scss');

export default class ComplementAdresseComponent {
  constructor() {
    this.controller = ComplementAdresseController;
    this.template = require('./complement-adresse.html');
    this.bindings = {
      prefix: '@',
      complementAdresse: '<',
      parentForm: '<',
      onComplementAdresseChange: '&'
    };
  }
}

// @ngInject
class ComplementAdresseController {

  $onInit() {
    this.communes = {
      loading: false,
      data: []
    };
    this.prefix = this.prefix ? this.prefix : '';
  }

  $onChanges(changes) {
    if (changes.complementAdresse) {
      this.data = this.complementAdresse ? this.complementAdresse : {};
    }
  }

  onChange() {
    this.onComplementAdresseChange({complementAdresse: this.data});
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/complement-adresse/complement-adresse.component.js